import React, { useEffect } from 'react';
import { SaludDoradaPage } from './pages/SaludDoradaPage';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <SaludDoradaPage data-id="element-0" />;
}